'use es6';

export const __proto__ = null;
export const LEFT = 'LEFT';
export const RIGHT = 'RIGHT';
export const TOP = 'TOP';
export const BOTTOM = 'BOTTOM';
export const CENTER = 'CENTER';